import { FC } from "react";
import { useTranslation, Trans } from "react-i18next";
import { Fade } from "@mui/material";
import { colors } from "helpers/consts";
import { ModalButton } from "components/Buttons";
import { AppText } from "components";
import {
  StatusContent,
  StatusDecorative,
  StatusIconContainer,
  InfoColumn,
  NotificationBlock,
} from "../styled";

import { ReactComponent as CheckIcon } from "assets/icons/check-circle.svg";
import { ReactComponent as MailIcon } from "assets/icons/mail.svg";

interface SuccessChangePhoneStepProps {
  onClose: () => void;
  oldNumber: string;
  newNumber: string;
}

const SuccessChangePhoneStep: FC<SuccessChangePhoneStepProps> = ({
  onClose,
  oldNumber,
  newNumber,
}) => {
  const { t } = useTranslation();

  return (
    <Fade in timeout={500}>
      <StatusContent>
        <StatusDecorative $noPadding $isTransparent>
          <StatusIconContainer $isStatic $isSuccess>
            <CheckIcon />
          </StatusIconContainer>
        </StatusDecorative>

        <InfoColumn>
          <AppText
            style={{ marginTop: "1.4rem" }}
            fontSize={18}
            fontWeight={600}
            color={colors.gray_700}
          >
            {t("PHONE_NUMBER_CHANGED_SUCCESSFULLY")}
          </AppText>

          <AppText
            style={{ marginTop: "0.8rem", maxWidth: "37rem" }}
            fontWeight={400}
            textAlign="center"
            color={colors.gray_600}
          >
            <Trans
              i18nKey="SUCCESS_CHANGE_NUMBER"
              values={{
                oldNumber: oldNumber,
                newNumber: newNumber,
              }}
            />
          </AppText>

          <NotificationBlock>
            <MailIcon />
            <AppText
              style={{ maxWidth: "32rem" }}
              fontWeight={400}
              color={colors.gray_700}
            >
              {t("NOTIFICATION_ABOUT_CHANGE")}
            </AppText>
          </NotificationBlock>

          <ModalButton style={{ marginTop: "1.4rem" }} onClick={onClose}>
            {t("RETURN_TO_PROFILE")}
          </ModalButton>
        </InfoColumn>
      </StatusContent>
    </Fade>
  );
};

export default SuccessChangePhoneStep;
